import { AuthService } from '../auth/AuthService';
import { ApiBack } from '../axios-config';

export interface RPSB {
    id_barragem?: string ;
    periodo_referencia: string;
    empresa_executora: string;
    data_inspecao: string;
    data_dce?: string | null | undefined;
    status_dce?: string;
    responsavel?: string;
    art?: string;
    orgao?: string;
    dpa?: string;
    cri?: string;
    classificacao?: string;
    uuid?: string;
    data_criacao?: string;
    verificacaoHidrologica: VerificacaoHidrologica;
    avaliacoes: Avaliacoes[];
    recomendacoes: Recomendacoes[];
    analiseEstabilidade: AnaliseEstabilidade;
  }
  
  // export Interface for AnaliseEstabilidade
  export interface AnaliseEstabilidade {
    modos_falha?: string;
    metodo_analise?: string;
    informacoes: InfoAnalises[];
  }

  export interface InfoAnalises {
    secao?: string;
    condicao?: string;
    fator_seguranca?: string;
    valor_referencia?: string;
  }
  
  export interface VerificacaoHidrologica {
    area_drenagem?: string;
    precipitacao_pmp?: string;
    precipitacao_projeto?: string;
    duracao_chuva?: string;
    vazao_maxima?: string;
    na_maximo_operacional?: string;
    na_maximo_maximorum?: string;
    borda_livre?: string;
    bombeamento?: string;
  }
  
  export interface Avaliacoes {
    estudo?: string;
    destaques?: string;
  }

  export interface Recomendacoes {
    recomendacao?: string;
    prazo?: string;
  }

const getAll = async (rpsb: string): Promise<RPSB[] | Error> => {

    await AuthService.verify();

    try{
        const token = await AuthService.getAccessToken();

        const response = await ApiBack.get(`./rpsbs?uuid=${rpsb}`, {
            headers: {
                Authorization: `${token}`
            }
        });        

        if(response.data){
            return response.data;
        }

        return new Error('Erro ao buscar dados', response.data);
    } catch (error: any) {
        if (error.response && error.response.data && error.response.data.error && error.response.data.message) {
            return new Error(error.response.data.message);
        } else {
            return new Error((error as { message: string }).message || 'Erro ao buscar dados', error);
        }
    }
};

const get = async (rpsb: string): Promise<RPSB | Error> =>{

    await AuthService.verify();

    try{
        const token = await AuthService.getAccessToken();

        const response = await ApiBack.get(`./rpsb?uuid=${rpsb}`, {
            headers: {
                Authorization: `${token}`
            }
        });

        if(response.data){
            return response.data;
        }

        return new Error('Erro ao buscar dados', response.data);
    } catch (error: any) {
        if (error.response && error.response.data && error.response.data.error && error.response.data.message) {
            return new Error(error.response.data.message);
        } else {
            return new Error((error as { message: string }).message || 'Erro ao buscar dados', error);
        }
    }
};

const create = async (data: RPSB): Promise<string | Error> => {

    await AuthService.verify();

    try{
        const token = await AuthService.getAccessToken();

        const response = await ApiBack.post('./rpsb', data, {
            headers: {
                Authorization: `${token}`
            }
        });

        if(response.data){
            return response.data;
        }

        return new Error('Erro ao buscar dados', response.data);

    }catch (error: any) {
        if (error.response && error.response.data && error.response.data.error && error.response.data.message) {
            return new Error(error.response.data.message);
        } else {
            return new Error((error as { message: string }).message || 'Erro ao buscar dados', error);
        }
    }

};

const upgrade = async (data: RPSB, rpsb: string): Promise<string | Error> => {

    await AuthService.verify();

    try{
        const token = await AuthService.getAccessToken();

        const response = await ApiBack.put(`./rpsb?uuid=${rpsb}`, data, {
            headers: {
                Authorization: `${token}`
            }
        });

        if(response.data){
            return response.data;
        }

        return new Error('Erro ao buscar dados', response.data);

    }catch (error: any) {
        if (error.response && error.response.data && error.response.data.error && error.response.data.message) {
            return new Error(error.response.data.message);
        } else {
            return new Error((error as { message: string }).message || 'Erro ao buscar dados', error);
        }
    }

};

const getAnomalias = async (uuid_barragem: string): Promise<any | Error> =>{

    await AuthService.verify();

    try{
        const token = await AuthService.getAccessToken();

        const response = await ApiBack.get(`./anomalias-atuais?uuid=${uuid_barragem}`, {
            headers: {
                Authorization: `${token}`
            }
        });

        if(response.data){
            return response.data;
        }

        return new Error('Erro ao buscar dados', response.data);
    } catch (error: any) {
        if (error.response && error.response.data && error.response.data.error && error.response.data.message) {
            return new Error(error.response.data.message);
        } else {
            return new Error((error as { message: string }).message || 'Erro ao buscar dados', error);
        }
    }
};

const deleteRPSB = async (uuid_rpsb: string): Promise<any | Error> =>{

    await AuthService.verify();

    try{
        const token = await AuthService.getAccessToken();

        const response = await ApiBack.delete(`./rpsb?uuid=${uuid_rpsb}`, {
            headers: {
                Authorization: `${token}`
            }
        });

        if(response){
            return response;
        }

        return new Error('Erro ao buscar dados', response);
    } catch (error: any) {
        if (error.response && error.response.data && error.response.data.error && error.response.data.message) {
            return new Error(error.response.data.message);
        } else {
            return new Error((error as { message: string }).message || 'Erro ao buscar dados', error);
        }
    }
};

export const ReportsServicesRpsb = {
    getAll,
    get,
    create,
    upgrade,
    getAnomalias,
    deleteRPSB
};
